export default {"src":"/assessments/student/_next/static/media/a.496825fd.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};